import { render } from "./favorite.vue?vue&type=template&id=79084b88&scoped=true"
import script from "./favorite.vue?vue&type=script&lang=js"
export * from "./favorite.vue?vue&type=script&lang=js"

import "./favorite.vue?vue&type=style&index=0&id=79084b88&scoped=true&lang=css"

import exportComponent from "/home/wido/Documents/Project/SS-GreedGreed/ss-web-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79084b88"]])

export default __exports__